import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { adminVerify } from '@/lib/api';

const AdminGuard = ({ children }) => {
  const [status, setStatus] = useState('checking'); // checking | authenticated | unauthenticated

  useEffect(() => {
    const verify = async () => {
      try {
        await adminVerify();
        setStatus('authenticated');
      } catch {
        localStorage.removeItem('admin_token');
        setStatus('unauthenticated');
      }
    };
    verify();
  }, []);

  if (status === 'checking') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FDFBF7]">
        <div className="spinner" style={{ width: '40px', height: '40px' }} />
      </div>
    );
  }

  if (status === 'unauthenticated') {
    return <Navigate to="/admin" replace />;
  }

  return children;
};

export default AdminGuard;
